import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import PasswordResetErrorResponse from './PasswordResetErrorResponse';

export default function updatePassword(
	client: ApiClient,
	token: string,
	userId: string,
	password: string
): Promise<void> {
	const url = parseTemplate('authentication/password/reset/{token}{?user}');

	return client
		.unauthenticatedFetch(url.expand({ token, user: userId }), {
			method: 'PUT',
			body: JSON.stringify({ password }),
		})
		.catch((response) => ApiClientErrorResponse.wrapError(response, PasswordResetErrorResponse));
}
